import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-blue-600 bg-blue-50 mb-6">
              <span className="text-sm font-medium text-blue-600">Confidentialité</span>
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Politique de confidentialité
            </h1>
            <p className="text-lg text-gray-600">
              Dernière mise à jour : 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Responsable du traitement
              </h2>
              <div className="space-y-2 text-base text-gray-700">
                <p><strong>Entreprise :</strong> Rafal Szelenc IT Services</p>
                <p><strong>Propriétaire :</strong> Rafal Jozef Szelenc</p>
                <p><strong>SIRET :</strong> 102 261 021 00012</p>
                <p><strong>Adresse :</strong> 73 Rue Fieux, 31100 Toulouse, France</p>
                <p><strong>Email :</strong> rafalszelenc@inbox.eu</p>
              </div>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                1. Introduction
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Rafal Szelenc IT Services accorde une grande importance à la protection de vos données personnelles et au respect de votre vie privée.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                La présente politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                2. Données collectées
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Ce site peut collecter certaines données personnelles via le formulaire de contact :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base text-gray-700 mb-4">
                <li>Nom et prénom</li>
                <li>Adresse e-mail</li>
                <li>Numéro de téléphone</li>
                <li>Message ou description du projet</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed">
                Ces données sont collectées uniquement lorsque vous remplissez volontairement le formulaire de contact.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                3. Finalité du traitement
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Les données personnelles collectées sont utilisées uniquement pour les finalités suivantes :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base text-gray-700">
                <li>Répondre à vos demandes de contact</li>
                <li>Vous fournir des informations sur nos services</li>
                <li>Établir un devis ou une proposition commerciale</li>
                <li>Assurer le suivi de votre demande</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                4. Base légale du traitement
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Le traitement de vos données personnelles repose sur votre consentement, que vous donnez en remplissant le formulaire de contact, ainsi que sur l'intérêt légitime de l'entreprise à répondre à vos demandes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Durée de conservation
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Vos données personnelles sont conservées pendant la durée nécessaire au traitement de votre demande, puis archivées conformément aux obligations légales en vigueur.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                6. Partage des données
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Les données personnelles ne sont ni vendues ni partagées avec des tiers.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Vos informations restent strictement confidentielles et sont utilisées uniquement par Rafal Szelenc IT Services pour répondre à vos demandes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                7. Sécurité des données
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Rafal Szelenc IT Services met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, perte, destruction ou divulgation.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                8. Vos droits
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base text-gray-700 mb-4">
                <li><strong>Droit d'accès :</strong> Vous pouvez demander l'accès à vos données personnelles</li>
                <li><strong>Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> Vous pouvez demander la suppression de vos données</li>
                <li><strong>Droit à la limitation :</strong> Vous pouvez demander la limitation du traitement</li>
                <li><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> Vous pouvez demander le transfert de vos données</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed">
                Pour exercer ces droits, contactez-nous à l'adresse : <a href="mailto:rafalszelenc@inbox.eu" className="text-blue-600 hover:underline cursor-pointer">rafalszelenc@inbox.eu</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                9. Cookies
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Ce site n'utilise pas de cookies de suivi ou de cookies publicitaires. Seuls des cookies techniques essentiels au fonctionnement du site peuvent être utilisés.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                10. Modifications de la politique
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Rafal Szelenc IT Services se réserve le droit de modifier la présente politique de confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur le site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                11. Contact
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Pour toute question relative aux données personnelles ou à la présente politique de confidentialité, contactez :
              </p>
              <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <p className="text-base text-gray-700 mb-2">
                  <strong>Email :</strong> <a href="mailto:rafalszelenc@inbox.eu" className="text-blue-600 hover:underline cursor-pointer">rafalszelenc@inbox.eu</a>
                </p>
                <p className="text-base text-gray-700 mb-2">
                  <strong>Téléphone :</strong> <a href="tel:+33605985260" className="text-blue-600 hover:underline cursor-pointer">+33 6 05 98 52 60</a>
                </p>
                <p className="text-base text-gray-700">
                  <strong>Adresse :</strong> 73 Rue Fieux, 31100 Toulouse, France
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                12. Réclamation
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Si vous estimez que vos droits ne sont pas respectés, vous avez le droit de déposer une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL).
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}